import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  public user: User;
  public sending = false;
  public sent = false;
  public error: string;

  sendPasswordReset(): void {
    // One email per request: ignore clicks while the last one is still being sent
    if (this.sending) {
      return;
    }
    this.error = null;
    this.sending = true;
    this.authService.sendPasswordResetEmail().subscribe(
      () => {
        this.sending = false;
        this.sent = true;
        this.snackBar.open('Password reset email sent', 'OK');
        this.mixpanelService.track('Action: Send password reset');
      },
      () => {
        this.sending = false;
        this.error = 'Unable to send password reset email. Please try again.';
      }
    );
  }

  constructor(
    private authService: AuthService,
    public snackBar: MatSnackBar,
    private mixpanelService: MixpanelService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.mixpanelService.track('Page: Change password');
    this.userService.currentUser()?.subscribe((user) => {
      this.user = user;
    });
  }
}
